import React from 'react';

const toc = [
  { id: 'types', label: 'types & values' },
  { id: 'control', label: 'control flow' },
  { id: 'function', label: 'functions' },
  { id: 'object', label: 'objects' },
  { id: 'memory', label: 'memory' },
  { id: 'thread', label: 'threads & sync' },
  { id: 'ffi', label: 'c ffi' },
  { id: 'ir', label: 'ir & code' },
];

function scrollTo(id) {
  const el = document.getElementById('api-' + id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}

export default function ApiRef() {
  return (
    <div className="doc-layout">
      <nav className="doc-sidebar">
        <div className="section">api reference</div>
        {toc.map(s => (
          <a key={s.id} href={'#api-' + s.id} onClick={e => { e.preventDefault(); scrollTo(s.id); }}>
            {s.label}
          </a>
        ))}
      </nav>
      <div className="doc-content">
        <h2>api reference</h2>

        <h3 id="api-types">types &amp; values</h3>
        <p>
          celest provides fixed-width byte slots (<code>byte[N]</code>),
          static-width inference (<code>byte[auto]</code>), and raw hex/string literals.
          values are copied by default; references use explicit addresses.
        </p>
        <pre>{`byte[1] one = byte(2A);
byte[2] word = 255 + 1;
byte[auto] inferred = 42;
byte[4] raw = byte(43 45 4C 53);
byte[6] text = "Celest";`}</pre>

        <h3 id="api-control">control flow</h3>
        <p>if/else, while, for, break, continue — standard block-structured control.</p>
        <pre>{`if (x > 0) {
  y = y - 1;
} else {
  y = 0;
}
for (byte[1] i = 0; i < 10; i = i + 1) {
  if (i == 5) break;
  if (i == 3) continue;
  process(i);
}`}</pre>

        <h3 id="api-function">functions</h3>
        <p>
          first-class, anonymous, closure-captured. zero to many return values.
          <code>this</code> binding via member call.
        </p>
        <pre>{`byte[8] add = function(a, b) { return a + b; };
byte[8] result = add(3, 4);

// multiple results
[quotient, remainder] = divide(17, 5);`}</pre>

        <h3 id="api-object">objects</h3>
        <p>dynamic properties, prototype chains, freeze/seal, identity hash.</p>
        <pre>{`byte[8] obj = new Object();
obj.answer = byte(2A 00 00 00);
byte[4] val = obj.answer;
Object.set_prototype(obj, proto);
Object.freeze(obj);`}</pre>

        <h3 id="api-memory">memory</h3>
        <p>
          raw allocate/release, aligned allocation, arena, bump, pool, slab,
          virtual memory, page protection, atomics with memory ordering.
        </p>
        <pre>{`byte[8] mem = Memory.allocate(64);
Memory.secure_zero(mem, 64);
Atomic.store(mem, 8, byte(2A 00 00 00 00 00 00 00), 0);
byte[8] val = Atomic.load(mem, 8, 0);
Memory.release(mem);`}</pre>

        <h3 id="api-thread">threads &amp; sync</h3>
        <p>spawn, join, detach, TLS, hardware concurrency. mutex, condition, semaphore, barrier, channel, rwlock, spin lock.</p>
        <pre>{`byte[8] t = Thread.spawn(worker);
byte[8] result = Thread.join(t);
Mutex.lock(mtx);
Condition.wait(cv, mtx);
Mutex.unlock(mtx);`}</pre>

        <h3 id="api-ffi">c ffi</h3>
        <p>direct <code>extern "C"</code> declarations, no binding generator needed.</p>
        <pre>{`extern "C" function puts(byte[8] text) -> byte[4]
byte[12] msg = "Hello FFI!\\0";
byte[4] ret = puts(&msg);`}</pre>

        <h3 id="api-ir">ir &amp; code</h3>
        <p>
          hir and ssa are first-class — inspect, verify, hot-replace.
          code versions can be pinned, collected, enumerated.
        </p>
        <pre>{`byte[auto] ir = hir {
  func @add
  block entry:
    v0 = param 0
    v1 = param 1
    v2 = add v0, v1
    return v2
};
Hir.install(target, ir);
Code.compile(target);`}</pre>
      </div>
    </div>
  );
}